import { createFileRoute } from "@tanstack/react-router";
import AmpaEs from "@/pages/es/AmpaEs";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_AMPA_URL = `${SITE_URL}/es/ampa`;

export const Route = createFileRoute("/es/ampa")({
  head: () => ({
    meta: [
      {
        title: "Terapia TMS Ampa One | Neuro Wellness TMS",
      },
      {
        name: "description",
        content:
          "Ampa One es TMS autorizado por la FDA, guiado por cámara, para la depresión que no ha respondido a los antidepresivos. Protocolo acelerado de 2 días, bobina.",
      },
      {
        property: "og:title",
        content: "Terapia TMS Ampa One | Neuro Wellness TMS",
      },
      {
        property: "og:description",
        content:
          "Ampa One es TMS autorizado por la FDA, guiado por cámara, para la depresión que no ha respondido a los antidepresivos. Protocolo acelerado de 2 días, suites privadas en Coral Springs, FL.",
      },
      { property: "og:url", content: ES_AMPA_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "Terapia TMS Ampa One | Neuro Wellness TMS",
      },
      {
        name: "twitter:description",
        content:
          "Ampa One es TMS autorizado por la FDA, guiado por cámara, para la depresión que no ha respondido a los antidepresivos. Protocolo acelerado de 2 días, suites privadas en Coral Springs, FL.",
      },
    ],
    links: [{ rel: "canonical", href: ES_AMPA_URL }, ...buildHreflang("/ampa")],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <AmpaEs />;
}
